import { Box, Typography } from '@mui/material';
import React from 'react';

export interface HeaderWithIconProps {
    title: string;
    Icon: React.FC<any>;
}

const HeaderWithIcon: React.FC<HeaderWithIconProps> = ({ title, Icon }) => {
    return (
        <Box display="flex" flexDirection="column" mb={2}>
            <Box display="flex" gap={3} alignItems="center">
                <Icon fontSize="large" />
                <Typography
                    variant="h4"
                    lineHeight="123.5%"
                    fontSize="34px"
                    letterSpacing="0.25px"
                    fontWeight={400}
                >
                    {title}
                </Typography>
            </Box>
        </Box>
    );
};

export default HeaderWithIcon;
